import { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil, isEmpty } from 'lodash';
// Import Components
import { LineChart, BusyLoader, Empty } from '@geneui/components';
import SectionWithTitle from 'components/common/SectionWithTitle';
// Import Constants
import { l } from 'constants/common';
// Import Services
import { Helpers } from 'services';

const { customMomentWithoutTimezoneConversion } = Helpers;

const CampaignEmailActivity = ({ isLoading, data }) => {
    const { OpenData, ClickData } = data;
    const { t } = useTranslation();
    const [xData, setOpenX] = useState<string[]>([]);
    const [openY, setOpenY] = useState<string[]>([]);
    const [clickY, setClickY] = useState<string[]>([]);

    const init = () => {
        let dataX: string[] = [];
        let dataY: string[] = [];
        if (!isNil(OpenData)) {
            OpenData.forEach(function ({ X, Y }) {
                dataX.push(customMomentWithoutTimezoneConversion(X).format('MMM DD'));
                dataY.push(Y);
            });
            setOpenX(dataX);
            setOpenY(dataY);
        }
        if (!isNil(ClickData)) {
            dataX = [];
            dataY = [];
            ClickData.forEach(function ({ X, Y }) {
                dataX.push(X);
                dataY.push(Y);
            });
            setClickY(dataY);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(init, [data]);

    return (
        <SectionWithTitle title={t(l.EmailActivity)} hasContentPadding={false} contentClassName="c-r-v-swt-content">
            <BusyLoader isBusy={isLoading} />
            {isNil(OpenData) && isEmpty(OpenData) ? (
                <Empty />
            ) : (
                <LineChart
                    categories={xData}
                    series={[
                        {
                            name: t(l.OpenData),
                            data: openY,
                        },
                        {
                            name: t(l.ClickData),
                            data: clickY,
                        },
                    ]}
                />
            )}
        </SectionWithTitle>
    );
};

CampaignEmailActivity.propTypes = {
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
};

CampaignEmailActivity.defaultProps = {
    isLoading: false,
};

export default memo(CampaignEmailActivity);
